import { SignalServiceBase } from "cayo.ui";

type AsyncRequestPoolingSignals = "startPooling";

type AsyncRequest = {
  requestId: string;
  status: string;
  message: string;
};

export const asyncRequestPoolingService = new SignalServiceBase<
  AsyncRequestPoolingSignals,
  AsyncRequest
>();
